import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
var convertBooleanValuesToString = function convertBooleanValuesToString(object) {
  return Object.fromEntries(Object.entries(object).map(function (item) {
    return typeof item[1] === 'boolean' ? [item[0], item[1].toString()] : item;
  }));
};
var isValidObject = function isValidObject(object) {
  return _typeof(object) === 'object' && Object.keys(object).length > 0;
};
var removeUndefinedAttributes = function removeUndefinedAttributes(object) {
  return Object.fromEntries(Object.entries(object).filter(function (a) {
    return Boolean(a[1]);
  }));
};
export default {
  convertBooleanValuesToString: convertBooleanValuesToString,
  isValidObject: isValidObject,
  removeUndefinedAttributes: removeUndefinedAttributes
};